export default { HEADER: 1, MODAL_BACKGROUND: 1000 };
